/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    'use strict';

    import IMeevoMessengerAutoReply = Meevo.Model.IMeevoMessengerAutoReply;

    class AutoReplyContoller implements ng.IComponentController {
        static $inject = [];

        public activatedBy: string;
        public message: string;
        public name: string;
        public isShowActivatedBy: boolean;

        constructor() { }

        $onInit() { }
    }

    class AutoReplyComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/meevoMessenger/components/autoReply/autoReply.template.html';
        controller = AutoReplyContoller;
        controllerAs = 'autoReply';
        bindings = {
            activatedBy: '<?',
            message: '<',
            name: '<',
            isShowActivatedBy: '=?',            
        };
    }

    angular.module('meevo.plugins.meevoMessenger')
        .component('meevoMessengerAutoReply', new AutoReplyComponent());

}

